import React from 'react'
import InputEditable from '../../../miscellaneous/InputEdit/InputEdit';

const KmlTable = (props) => {
  return (
    <div className="content-line">
      <div className="line line-100">
        <table className="table-layers-results-kml">
          <thead>
            <tr>
              <th className="table-column-name no-select">Capa</th>
              <th className="table-column-actions no-select">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {props.content.map((item, index) => (
              <tr key={"row-table-hg ash-" + index}>
                <td className="table-column-user no-select pointer" onDoubleClick={() => props.dobleClick(index)}>
                  {
                    item.edit ?
                      <InputEditable text={item.name} onAccept={props.update} onCancel={props.cancel} id={item.id} /> :
                      item.name
                  }
                </td>
                <td className="table-column-actions">
                  {!!item.active ?
                    <i className="fas fa-toggle-on state-layer-icon green-color" onClick={() => props.activate(item.id, false)} title='Desactivar'></i>
                    :
                    <i className="fas fa-toggle-off state-layer-icon" onClick={() => props.activate(item.id, true)} style={{ color: 'gray' }} title='Activar'></i>
                  }
                  <a href={item.url}><i className="fas fa-file-download state-layer-icon primary-color" title='Descargar' style={{ marginLeft: '20px' }} ></i></a>
                  <i className="far fa-trash-alt state-layer-icon red-color" onClick={() => props.delete(item.id)} style={{ marginLeft: '20px' }} title='Eliminar'></i>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default KmlTable;